import { connect } from 'react-redux';

import { removeError } from '../../../redux/actions';
import { selectModalError } from '../../../redux/errors/registry.errors';
import ErrorModal from './error-modal';

export const mapStateToProps = (state, { errorRegistry }) => {
  const error = selectModalError(state, errorRegistry);
  return {
    error,
    errorIsVisible: Boolean(error),
  };
};

export const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  popError: () => dispatch(removeError(stateProps.error)),
});

export default connect(mapStateToProps, null, mergeProps)(ErrorModal);
